// aiSessionPrefs.js — last-active session + Sessions panel collapse (localStorage)

const STORAGE_KEY = 'orbital.ai.sessions.prefs.v1';

function cleanString(value) {
  return String(value || '').trim();
}

function buildScopeKey(baseKey, userKey) {
  const ws = cleanString(baseKey);
  const uid = cleanString(userKey);
  if (!ws || !uid) return '';
  return `${ws}:${uid}`;
}

function readAll() {
  if (typeof window === 'undefined' || !window?.localStorage) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(nextMap) {
  if (typeof window === 'undefined' || !window?.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextMap || {}));
  } catch {
    // ignore quota / private mode
  }
}

function readScope(baseKey, userKey) {
  const scope = buildScopeKey(baseKey, userKey);
  if (!scope) return {};
  const all = readAll();
  const row = all[scope];
  return row && typeof row === 'object' ? row : {};
}

function writeScope(baseKey, userKey, patch = {}) {
  const scope = buildScopeKey(baseKey, userKey);
  if (!scope) return;
  const all = readAll();
  all[scope] = {
    ...(all[scope] && typeof all[scope] === 'object' ? all[scope] : {}),
    ...patch,
  };
  writeAll(all);
}

export function getLastActiveSessionKey({ baseKey, userKey } = {}) {
  return cleanString(readScope(baseKey, userKey).lastActiveSessionKey);
}

export function setLastActiveSessionKey({ baseKey, userKey, sessionKey } = {}) {
  const key = cleanString(sessionKey);
  if (!key) return;
  writeScope(baseKey, userKey, { lastActiveSessionKey: key });
}

export function getSessionsPanelCollapsed({ baseKey, userKey } = {}) {
  return readScope(baseKey, userKey).sessionsPanelCollapsed === true;
}

export function setSessionsPanelCollapsed({ baseKey, userKey, collapsed } = {}) {
  writeScope(baseKey, userKey, { sessionsPanelCollapsed: collapsed === true });
}
